import React from 'react';
import ChartHeader from './header';
import ChartContent from './content';

const Chart = () => {
    return (
        <div className="chart">
            <ChartHeader />
            <ChartContent />
        </div>
    )
}

export default Chart;